import { BaseAndCrudRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class BillingRoutes extends BaseAndCrudRoutes {
	constructor() {
		super('billing');
	}
}
